export const noop = (): void => {
   /** Expected empty */
};
